import classNames from 'classnames';
import * as React from 'react';

const submitButtonClassNames = 'btn btn-primary btn-green btn-block';
const disabledButtonClassNames =
  'btn btn-block btn-md gray size-md disabled bold';

interface ButtonProps {
  label: string;
  buttonClassNames: string;
}

interface SubmitButtonProps extends ButtonProps {
  isSubmitting: boolean;
}

export const SubmitButton: React.FC<SubmitButtonProps> = (
  props: SubmitButtonProps,
) => {
  const { label, buttonClassNames, isSubmitting } = props;
  return (
    <button
      type="submit"
      id="submit"
      className={
        isSubmitting
          ? classNames(disabledButtonClassNames, buttonClassNames)
          : classNames(submitButtonClassNames, buttonClassNames)
      }
      disabled={isSubmitting}
    >
      {isSubmitting && <i className="icon icon-loading icon-loading-center" />}
      {label}
    </button>
  );
};
SubmitButton.displayName = 'SubmitButton';

export const DisabledButton: React.FC<ButtonProps> = (props: ButtonProps) => {
  const { label, buttonClassNames } = props;
  return (
    <a className={classNames(disabledButtonClassNames, buttonClassNames)}>
      {label}
    </a>
  );
};
DisabledButton.displayName = 'DisabledButton';
